import classNames from "classnames";

/** The parts of a sequence-state marker the dot depends on. */
export interface SequenceStateDotSource {
  changed: boolean;
  uncertain?: boolean;
  /** The attachment marker draws this marker's dot instead (it holds a prop). */
  holdsProp?: boolean;
}

/**
 * Badge content for InteractionPointPreview: an empty badge styled as the dot
 * (Viewport3D.css). Undefined draws no badge. An actor marker in an uncertain
 * place gets no dot: its dashed border (sequenceUncertainClassName) says it.
 */
export const sequenceStateDot = (source?: SequenceStateDotSource | null) =>
  source?.changed && !source.holdsProp && !source.uncertain ? "" : undefined;

/** Icon class for an actor marker in an uncertain place (parallel branches in no fixed order): a dashed border (Viewport3D.css). */
export const sequenceUncertainClassName = (source?: SequenceStateDotSource | null) =>
  source?.uncertain ? "sequence-uncertain" : undefined;

/** Filled: placed by the sequence. Hollow: parallel branches may leave it elsewhere. */
export const sequenceStateDotClassName = (source?: SequenceStateDotSource | null) =>
  classNames("sequence-state-badge", {
    "sequence-state-badge--maybe": source?.uncertain,
  });
